import axios from "axios";
import { PROXY_RATES } from "../envVariables";

// Direct Cloud Run endpoint, or the same-origin Netlify proxy when REACT_APP_PROXY_RATES=YES
// (the proxy also swaps the anonymous JWT placeholder for a real one — see rate-search.mjs).
const DIRECT_URL = "https://rate-api-462238530065.us-central1.run.app/fcl-external-rates";
const PROXY_URL = "/api/fcl-external-rates";

export const makeGCPRequestForFCLExternalRate= async (payload) => {
    // console.log("--makeGCPRequestForFCLExternalRate--", JSON.stringify(payload, null, 2));

    const url = PROXY_RATES === "YES" ? PROXY_URL : DIRECT_URL;

    try{
        const response = await axios.post(url, payload, {
            headers: { "Content-Type": "application/json" },
        });
        // console.log("----response------",response)

        const { status, data } = response;
        console.log("GCP Response status:", status); 
        if (data?.ok) {
            if (data.error) {
                // Throw an error if API explicitly reports one
                throw new Error(
                `GCP request error: ${typeof data.error === "string" ? data.error : JSON.stringify(data.error)}`
                );
            }

            const results = data?.results || [];

            if (Array.isArray(results)) {
                console.log("✅ GCP Request for fcl-external-rates accepted");
                return results;
            }

            if (results && typeof results === "object") {
                const status = results?.status || results.code;
                const errorMsg = results?.error || results.message;
                if (status && errorMsg) {
                    console.error(
                        `⚠️ SpotOn returned ${status}: ${errorMsg}`
                    );
                    return [];
                }
            }
        }

        console.warn("⚠️ GCP Request for fcl-external-rates not accepted:", data);
        return [];
    }catch(error){
        console.error("error while getting fcl external rate: ",error);
        const responseData = error.response?.data;
        if (responseData) {
            const status =
              responseData?.results?.status ||
              responseData?.status ||
              error.response?.status;
            const message =
              responseData?.results?.error ||
              responseData?.error ||
              responseData?.message ||
              error.message;
            return `SpotOn error (${status || 'unknown'}): ${message}`;
        }
        return `SpotOn request failed: ${error.message}`;
    }
  
}
